import React, { useId, useState } from 'react';
import styles from './Disclosure.module.css';
import ChevronIcon from './ChevronIcon';

const clsx = (...args) => args.filter(Boolean).join(' ');

function Disclosure({
  summary,
  title,
  subtitle,
  children,
  defaultOpen = false,
  open: controlledOpen,
  onChange,
  tone = 'light',
  variant = 'default',
  className,
}) {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : uncontrolledOpen;
  const contentId = useId();

  const toggle = () => {
    const next = !open;
    if (!isControlled) setUncontrolledOpen(next);
    onChange?.(next);
  };

  // `title` (with optional `subtitle`) takes precedence over `summary` for the
  // common "section header" use case. `summary` remains for cases where the
  // header is a custom ReactNode (badges, icons, etc.).
  const summaryContent = title ? (
    <span className={styles.titleBlock}>
      <span className={styles.title}>{title}</span>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </span>
  ) : (
    <span className={styles.summaryText}>{summary}</span>
  );

  return (
    <div
      className={clsx(
        styles.disclosure,
        styles[variant],
        tone === 'dark' && styles.onDark,
        open && styles.open,
        className
      )}
    >
      <button
        type="button"
        className={styles.summary}
        aria-expanded={open}
        aria-controls={contentId}
        onClick={toggle}
      >
        {summaryContent}
        <ChevronIcon open={open} />
      </button>
      <div
        id={contentId}
        className={clsx(styles.contentWrap, open && styles.contentWrapOpen)}
      >
        <div className={styles.contentInner}>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Disclosure;
